export class AnswersAddDetails {
    constructor(
        public CriteriaId: string,
        public Options: Array<string>
    ) { }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/models/dto/answers.ts